import { Box, Typography } from "@mui/material";
import React from "react";
import { MrnChip } from "../../../common/MrnChip";

const PatientTitle = ({ title, mrn }: { title: string; mrn?: string }) => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: "6px", minWidth: 0 }}
    >
      <Typography
        data-testid="patient-name"
        sx={{
          fontWeight: "500",
          textTransform: "capitalize",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        noWrap
      >
        {title}
      </Typography>
      {mrn && <MrnChip mrn={mrn} />}
    </Box>
  );
};

export default PatientTitle;
